(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/side-nav/assets/javascripts/lazy-competition-result.js') >= 0) return;  svs.modules.push('/components/tipsen/side-nav/assets/javascripts/lazy-competition-result.js');
"use strict";

const {
  tipsenLazy
} = svs.components.tipsen.tipsenLazy;
const LazyCompetitionResult = tipsenLazy('/cl/tipsen/route-mybets-competition', () => svs.components.tipsen.routeMybetsCompetition.MybetsCompetition);
setGlobal('svs.components.tipsen.sideNav.LazyCompetitionResult', LazyCompetitionResult);

 })(window);